import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { question } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useGetAssetAssociationGraph = (cleanRoomID, questionId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    (data) => axiosInstance.post(question(orgId)
      .getAssetAssociationGraph(cleanRoomID, questionId), data),
    {
      onError: () => {
        dispatch(showAlert({
          message: 'Error fetching asset association graph',
          type: 'error',
        }));
      },
    },
  );
};
